// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"ContactData_FormContainer__2hvgB","ContactInfoContainer":"ContactData_ContactInfoContainer__1iQVT","SubmitButton":"ContactData_SubmitButton__8pnDt"};